/**
 * Condition info dialog: open/close via event delegation.
 * Dialog may not be inside the wrapper in the live DOM (browser/theme can move it),
 * so we fall back to document.querySelector('.condition-info-modal') when needed.
 */
(function () {
  var scrollY = 0;

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.condition-info-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var wrapper = trigger.closest('.condition-info-dialog');
      var dialog = (wrapper && wrapper.querySelector('.condition-info-modal')) || (trigger.nextElementSibling && trigger.nextElementSibling.tagName === 'DIALOG' ? trigger.nextElementSibling : null);
      if (!dialog && wrapper) {
        for (var i = 0; i < wrapper.children.length; i++) {
          if (wrapper.children[i].tagName === 'DIALOG') { dialog = wrapper.children[i]; break; }
        }
      }
      if (!dialog && wrapper) dialog = wrapper.querySelector('dialog');
      if (!dialog) {
        var section = trigger.closest('.shopify-section');
        dialog = section ? section.querySelector('.condition-info-modal') : null;
      }
      if (!dialog) dialog = document.querySelector('.condition-info-modal');
      if (dialog && typeof dialog.showModal === 'function') {
        scrollY = window.scrollY;
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.width = '100%';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + scrollY + 'px';
        document.body.style.paddingRight = scrollbarWidth > 0 ? scrollbarWidth + 'px' : '';
        dialog.addEventListener('close', function onClose() {
          document.body.style.width = '';
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.paddingRight = '';
          window.scrollTo({ top: scrollY, behavior: 'instant' });
        }, { once: true });
        dialog.showModal();
      }
      return;
    }

    var closeBtn = e.target.closest('.condition-info-modal__close');
    if (closeBtn) {
      e.preventDefault();
      var d = closeBtn.closest('.condition-info-modal');
      if (d && typeof d.close === 'function') d.close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openDialog = document.querySelector('.condition-info-modal[open]');
    if (openDialog && typeof openDialog.close === 'function') openDialog.close();
  });
})();
